import {useState} from 'react';
import {Link} from "react-router-dom";

function Search(props) {
    const [category,setCategory] = useState([
        {
            id:1,
            name: 'مهمونی',
        },
        {
            id:2,
            name: 'مناسبتی',
        },
        {
            id:3,
            name: 'سنتی',
        },
        {
            id:4,
            name: 'محلی',
        },
        {
            id:5,
            name: 'شاد',
        },
        {
            id:6,
            name: 'رپ',
        },
        {
            id:7,
            name: 'تلفیقی',
        },
        {
            id:8,
            name: 'پربازدید ترین',
        },
        {
            id:9,
            name: 'جدیدترین ها',
        },
    ])
    const background = {
        1 : 'bg-sky-500',
        2 : 'bg-rose-500',
        3 : 'bg-fuchsia-500',
        4 : 'bg-indigo-500',
        5 : 'bg-pink-500',
        6 : 'bg-yellow-400',
        7 : 'bg-rose-500',
        8 : 'bg-green-500',
        9 : 'bg-orange-500',

    }
    return (
        <div className='flex flex-col'>
            <div className='text-violet-800 font-black text-base md:text-lg mb-6'>بازدید همه</div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {
                    category.map((item,index) =>
                        <div className={`${background[index+1]} flex items-center justify-center rounded h-[200px]`}>
                            <div className="text-white font-bold text-lg">{item.name}</div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default Search;